import React, { useEffect, useState } from "react";
import {
  FaMapMarkerAlt,
  FaBuilding,
  FaRegCalendarAlt,
  FaUsers,
  FaMicrophoneAlt,
  FaGlobeAmericas,
  FaGlobe,
  FaHandshake,
  FaChartLine,
  FaMountain,
  FaArrowRight,
  FaLightbulb,
  FaBook,
  FaCogs,
  FaInstagram,
  FaLinkedin,
} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import Header from "../../SubComponents/Header";
import Footer from "../../SubComponents/footer";
import "./style.css";

// ─── Hero / About ───────────────────────────────────────────
import orig from "../../assets/img/firstbak.png";
import investforum from "../../assets/img/G10.png";
import aboutForumImg from "../../assets/img/About Forum.png";
import hand from "../../assets/img/hand.jpg";

// ─── Speakers ───────────────────────────────────────────────
import speakerDilshod from "../../assets/img/speaker_new_dilshod_jurazoda.jpg";
import speakerGagan from "../../assets/img/Гаган Малхотра (2).jpg";
import speakerElena from "../../assets/img/speaker-elena-son.jpg";
import speakerTaejun from "../../assets/img/speaker-gud-shin.jpg";
import speakerAnastasia from "../../assets/img/Anastasi.jpg";
import speakerSaidmurod from "../../assets/img/Саидмурод Давлатов.jpg";
import speakerOzodkhon from "../../assets/img/Озодхон Давлатшоев (2).jpg";
import speakerBehdad from "../../assets/img/Behdad.jpg";
import speakerAbdurashid from "../../assets/img/speaker-abdurashid-iminov.jpg";
import speakerHarpreet from "../../assets/img/speaker-harpreet-singh-maan.jpg";

// ─── Organizers ─────────────────────────────────────────────
import organizerLogo1 from "../../assets/img/gerb.png";
import organizerLogo2 from "../../assets/img/tajinvest-logo-organizer.png";
import organizerLogo3 from "../../assets/img/Coat_of_Arms_of_Dushanbe.png";

// ─── Partners / Sponsors ────────────────────────────────────
import sebistonLogo from "../../assets/img/sebistonen.png";
import tcellLogo from "../../assets/img/tcell.png";
import fiftyFiveLogo from "../../assets/img/fifty-five.png";
import asiaPlusLogo from "../../assets/img/asia-plus.png";
import accelerateLogo from "../../assets/img/accel.png";
import turkishAirLogo from "../../assets/img/turkishair.png";
import hovarLogo from "../../assets/img/hovarDigar.png";
import ADBLogo from "../../assets/img/ADB.JPG";
import VaslLogo from "../../assets/img/Vasl Bank.png";

const TICKET_URL =
  "https://ticketon.tj/knowledge-skills/event/tckt2-g10-insights-forum-2026";

const ImagePlaceholder = ({ label, className = "", src, alt = "" }) => {
  if (src) {
    return (
      <div className={`if-img-frame ${className}`}>
        <img src={src} alt={alt} className="if-img" />
      </div>
    );
  }
  return (
    <div className={`if-img-placeholder ${className}`}>
      <span>{label}</span>
    </div>
  );
};

const speakerPhotos = [
  speakerDilshod,
  speakerGagan,
  speakerElena,
  speakerTaejun,
  speakerAnastasia,
  speakerSaidmurod,
  speakerOzodkhon,
  speakerBehdad,
  speakerAbdurashid,
  speakerHarpreet,
];

const partnerGroups = [
  {
    categoryKey: 0,
    logos: [{ src: sebistonLogo, alt: "Sebiston", className: "sebiston-logo" }],
  },
  {
    categoryKey: 1,
    logos: [
      { src: tcellLogo, alt: "Tcell" },
      { src: fiftyFiveLogo, alt: "FIFTYFIVE GROUP" },
    ],
  },
  {
    categoryKey: 2,
    logos: [{ src: ADBLogo, alt: "ADB" }],
  },
  {
    categoryKey: 3,
    logos: [
      { src: turkishAirLogo, alt: "Turkish Airlines" },
      { src: VaslLogo, alt: "Vasl Bank" },
      { src: accelerateLogo, alt: "Accelerate Prosperity" },
    ],
  },
  {
    categoryKey: 4,
    logos: [
      { src: asiaPlusLogo, alt: "Asia-Plus" },
      { src: hovarLogo, alt: "Ховар" },
    ],
  },
];

const missionIcons = [
  <FaChartLine />,
  <FaGlobe />,
  <FaHandshake />,
  <FaMountain />,
];

const statIcons = [
  <FaUsers />,
  <FaMicrophoneAlt />,
  <FaGlobeAmericas />,
  <FaHandshake />,
];

const outcomeIcons = [
  <FaLightbulb />,
  <FaBook />,
  <FaHandshake />,
  <FaUsers />,
  <FaCogs />,
  <FaChartLine />,
];

const InvestForum = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const agendaPdf =
    lang === "en"
      ? `${process.env.PUBLIC_URL}/files/agenda-g10-insights-forum-en.pdf`
      : `${process.env.PUBLIC_URL}/files/agenda-g10-insights-forum-ru.pdf`;

  const stats = t("investForum.stats", { returnObjects: true }) || [];
  const missionGoals =
    t("investForum.missionGoals", { returnObjects: true }) || [];
  const speakers = t("investForum.speakers", { returnObjects: true }) || [];
  const expectedOutcomes =
    t("investForum.outcomes", { returnObjects: true }) || [];
  const partnerCategories =
    t("investForum.partnerCategories", { returnObjects: true }) || [];

  const SPEAKERS_PER_PAGE = 5;
  const AUTO_SWIPE_INTERVAL = 4500;
  const [speakerPage, setSpeakerPage] = useState(0);
  const [isCarouselPaused, setIsCarouselPaused] = useState(false);

  const speakerPageCount = Math.ceil(speakers.length / SPEAKERS_PER_PAGE);

  useEffect(() => {
    if (speakerPageCount <= 1 || isCarouselPaused) return undefined;
    const interval = setInterval(() => {
      setSpeakerPage((prev) => (prev + 1) % speakerPageCount);
    }, AUTO_SWIPE_INTERVAL);
    return () => clearInterval(interval);
  }, [speakerPageCount, isCarouselPaused]);

  const visibleSpeakers = speakers.slice(
    speakerPage * SPEAKERS_PER_PAGE,
    speakerPage * SPEAKERS_PER_PAGE + SPEAKERS_PER_PAGE,
  );

  const visibleSpeakerPhotos = speakerPhotos.slice(
    speakerPage * SPEAKERS_PER_PAGE,
    speakerPage * SPEAKERS_PER_PAGE + SPEAKERS_PER_PAGE,
  );

  // ─── Detailed Agenda (full translations including names) ─────────────
  const detailedAgenda = [
    {
      type: "block",
      time: "09:00 – 10:00",
      title:
        lang === "tj"
          ? "Сабти номи иштирокчиён. Қаҳваи хушомадгӯӣ"
          : lang === "ru"
            ? "Регистрация участников. Приветственный кофе"
            : "Participant Registration. Welcome Coffee",
      color: "teal",
    },
    {
      type: "block",
      time: "10:00 – 10:30",
      title:
        lang === "tj"
          ? "Маросими ифтитоҳи форум"
          : lang === "ru"
            ? "Церемония открытия форума"
            : "Forum Opening Ceremony",
      color: "teal",
    },
    {
      type: "session",
      title:
        lang === "tj" ? "Ҷаласаи 1" : lang === "ru" ? "Сессия 1" : "Session 1",
      subtitle:
        lang === "tj"
          ? "Таърихҳои муваффақият"
          : lang === "ru"
            ? "Истории успеха"
            : "Success Stories",
      timeRange: "10:30 – 13:00",
      color: "gold",
      items: [
        {
          time: "10:30 – 11:00",
          photo: speakerTaejun,
          name:
            lang === "tj"
              ? "Теҷун Шин"
              : lang === "ru"
                ? "Тэджун Шин"
                : "Taejun Shin",
          langLabel: "(in English)",
          country: lang === "tj" ? "Ҷопон" : lang === "ru" ? "Япония" : "Japan",
          title:
            lang === "tj"
              ? "Асосгузор, шарики идоракунанда ва директори генералии Gojo & Company."
              : lang === "ru"
                ? "Основатель, управляющий партнёр и CEO Gojo & Company."
                : "Founder, Managing Partner and CEO of Gojo & Company.",
          topic:
            lang === "tj"
              ? "Gojo: Пешбурди фарогирии молиявӣ дар Осиёи Марказӣ ва берун аз он"
              : lang === "ru"
                ? "Gojo: Продвижение финансовой инклюзии в Центральной Азии и за её пределами"
                : "Gojo: Advancing Financial Inclusion in Central Asia and Beyond",
          qa: true,
        },
        {
          time: "11:00 – 11:30",
          photo: speakerElena,
          name:
            lang === "tj" || lang === "ru"
              ? "Елена В. Сон-ЛаРокко"
              : "Elena V. Son-LaRocco",
          langLabel: "(in English)",
          country: lang === "tj" ? "ИМА" : lang === "ru" ? "США" : "USA",
          title:
            lang === "tj"
              ? "Директори иҷроияи Шӯрои тиҷоратии ИМА–Тоҷикистон. Пешвои бизнес ва мутахассис оид ба рушди робитаҳои иқтисодӣ байни ИМА ва Осиёи Марказӣ."
              : lang === "ru"
                ? "Исполнительный директор Делового совета США–Таджикистан. Бизнес-лидер и эксперт по экономическим отношениям США и Центральной Азии."
                : "Executive Director of the U.S. – Tajikistan Business Council. Business leader and expert in U.S. - Central Asia economic relations",
          topic:
            lang === "tj"
              ? "ИМА ва Осиёи Марказӣ: роҳандозии шарикии мутақобилан судманди тиҷоратӣ"
              : lang === "ru"
                ? "США и Центральная Азия: построение взаимовыгодных деловых партнёрств"
                : "US and Central Asia: Building Mutually Beneficial Business Partnerships",
          qa: true,
        },
        {
          time: "11:30 – 12:00",
          photo: speakerGagan,
          name:
            lang === "tj" || lang === "ru"
              ? "Гаган Малхотра"
              : "Gagan Malhotra",
          langLabel: "(in English)",
          country:
            lang === "tj" ? "Ҳиндустон" : lang === "ru" ? "Индия" : "India",
          title:
            lang === "tj"
              ? "Соҳибкор, сармоягузор, директори идоракунандаи CHL International, соҳиби меҳмонхонаи Hilton Dushanbe. Муовини раиси AmCham Tajikistan."
              : lang === "ru"
                ? "Предприниматель, инвестор, управляющий директор CHL International, владелец отеля Hilton Dushanbe. Заместитель председателя AmCham Tajikistan."
                : "Entrepreneur, Investor, Managing Director of CHL International, owner of the Hilton Dushanbe Hotel. Vice chairman of AmCham Tajikistan",
          topic:
            lang === "tj"
              ? "Сайёҳӣ: муҳаррики рушди Тоҷикистон"
              : lang === "ru"
                ? "Туризм: двигатель роста Таджикистана"
                : "Tourism: The Growth Engine for Tajikistan",
          qa: true,
        },
        {
          time: "12:00 – 12:30",
          photo: speakerSaidmurod,
          name:
            lang === "tj" || lang === "ru"
              ? "Саидмурод Давлатов"
              : "Saidmurod Davlatov",
          langLabel: "",
          country:
            lang === "tj"
              ? "Тоҷикистон"
              : lang === "ru"
                ? "Таджикистан"
                : "Tajikistan",
          title:
            lang === "tj"
              ? "Асосгузори Маркази байналмилалии рушди инсонии «САМО», соҳибкор, сармоягузор ва мураббии бизнес."
              : lang === "ru"
                ? "Основатель Международного центра развития человека «САМО», предприниматель, инвестор и бизнес-коуч."
                : "Founder of the SAMO International Human Development Center, entrepreneur, investor and business coach.",
          topic:
            lang === "tj"
              ? "Системаи рушди фоида бе зиёд кардани бори корӣ"
              : lang === "ru"
                ? "Система роста прибыли без увеличения рабочей нагрузки"
                : "A Profit Growth System Without Increasing Workload",
          qa: true,
        },
        {
          time: "12:30 – 13:00",
          photo: speakerOzodkhon,
          name:
            lang === "tj" || lang === "ru"
              ? "Озодхон Давлатшоев"
              : "Ozodkhon Davlatshoev",
          langLabel: "(in English)",
          country:
            lang === "tj"
              ? "Тоҷикистон"
              : lang === "ru"
                ? "Таджикистан"
                : "Tajikistan",
          title:
            lang === "tj"
              ? "Директори генералии Tcell; топ-менеҷер, коршиноси телекоммуникатсия, сармоягузор ва мутахассиси финтех; хатмкардаи Harvard Business School."
              : lang === "ru"
                ? "Генеральный директор Tcell; топ-менеджер, эксперт по телекоммуникациям, инвестор и финтех-специалист; выпускник Harvard Business School."
                : "CEO of Tcell; Top executive, telecommunications expert, investor and fintech specialist; Harvard Business School graduate.",
          topic:
            lang === "tj"
              ? "Аз пайвастшавӣ то эътимоди рақамӣ: Tcell ҳамчун қабати инфрасохтории иқтисоди рақамии Тоҷикистон"
              : lang === "ru"
                ? "От связи к цифровому доверию: Tcell как инфраструктурный слой цифровой экономики Таджикистана"
                : "From Connectivity to Digital Trust: Tcell as the Infrastructure Layer of Tajikistan's Digital Economy",
          qa: true,
        },
      ],
    },
    {
      type: "panel",
      time: "13:00 – 14:00",
      title:
        lang === "tj"
          ? "Ҷаласаи панелӣ"
          : lang === "ru"
            ? "Панельная сессия"
            : "Panel Session",
      subtitle:
        lang === "tj"
          ? "Тиҷорати электронӣ ҳамчун омили рушди сармоягузорӣ: маркетплейсҳо, пардохтҳо ва логистикаи насли нав"
          : lang === "ru"
            ? "Электронная коммерция как драйвер инвестиций: маркетплейсы, платежи и логистика нового поколения"
            : "E-Commerce as a Driver of Investment: Marketplaces, Payments and Next-Generation Logistics",
      moderator:
        lang === "tj" || lang === "ru"
          ? "Насима Бахрамова"
          : "Nasima Bakhramova",
      moderatorTitle:
        lang === "tj"
          ? "Раиси Ассотсиатсияи иштирокчиёни тиҷорати электронии Тоҷикистон"
          : lang === "ru"
            ? "Председатель Ассоциации участников электронной коммерции Таджикистана"
            : "Chairwoman of the Association of E-Commerce Participants of Tajikistan",
      panelistsLabel:
        lang === "tj"
          ? "Барномаи ҷаласаи панелӣ"
          : lang === "ru"
            ? "Программа панельной сессии"
            : "Panel session program",
      panelists:
        lang === "tj"
          ? [
              { time: "13:00 – 13:05", name: "Насима Баҳромова — раиси АУЭКТ", topic: "Ифтитоҳи сессия: «Аз интернет-мағоза то бозори сармоягузорӣ: барои васеъ шудани тиҷорати электронии Тоҷикистон чӣ лозим аст?»" },
              { time: "13:05 – 13:12", name: "Ифтихор Юсуфӣ — маркетплейси LAK LAK", topic: "Маркетплейси маҳаллӣ ҳамчун инфрасохтори рушди тиҷорати хурд ва ҷалби сармоягузорӣ" },
              { time: "13:12 – 13:19", name: "Муҳаммадҷон Қудратуллозода — агрегатори логистикии тиҷорати электронӣ", topic: "Мили охирин ва fulfillment ҳамчун инфрасохтори сармоягузорӣ" },
              { time: "13:19 – 13:26", name: "Гуланор Атобек — намояндаи ширкати финтекӣ / низоми пардохтӣ", topic: "Инфрасохтори пардохт барои тиҷорати электронӣ: аз QR ва эквайринг то муомилоти ягонаи рақамӣ" },
              { time: "13:26 – 13:33", name: "Ярослав Еферин — лоиҳаи «Парвона»", topic: "Чӣ гуна соҳибкорро аз шабакаҳои иҷтимоӣ ба тиҷорати электронии низомнок гузаронем?" },
              { time: "13:33 – 13:40", name: "Бону Бобоева — директори амалиётии zehnlab.ai", topic: "Чӣ гуна AI ва автоматикунонии рақамӣ иқтисоди тиҷорати онлайниро тағйир медиҳанд" },
              { time: "13:40 – 13:55", name: "Муҳокимаи идорашаванда", topic: "Дискуссияи модерируемая ва раунди кӯтоҳ" },
              { time: "13:55 – 14:00", name: "Насима Баҳромова", topic: "Хулосаи модератор" },
            ]
          : lang === "ru"
            ? [
                { time: "13:00 – 13:05", name: "Насима Бахрамова — председатель АУЭКТ", topic: "Открытие сессии: «От интернет-магазина к инвестиционному рынку: что необходимо, чтобы e-commerce Таджикистана масштабировался?»" },
                { time: "13:05 – 13:12", name: "Ифтихор Юсуфи — маркетплейс LAK LAK", topic: "Локальный маркетплейс как инфраструктура роста малого бизнеса и привлечения инвестиций" },
                { time: "13:12 – 13:19", name: "Мухаммаджон Кудратуллозода — логистический агрегатор электронной коммерции", topic: "Последняя миля и fulfillment как инвестиционная инфраструктура" },
                { time: "13:19 – 13:26", name: "Гуланор Атобек — представитель финтех-компании / платёжной системы", topic: "Платёжная инфраструктура для e-commerce: от QR и эквайринга до единой цифровой сделки" },
                { time: "13:26 – 13:33", name: "Ярослав Еферин — проект «Парвона»", topic: "Как вывести предпринимателя из социальных сетей в системную электронную коммерцию?" },
                { time: "13:33 – 13:40", name: "Бону Бобоева — операционный директор zehnlab.ai", topic: "Как AI и цифровая автоматизация меняют экономику онлайн-торговли" },
                { time: "13:40 – 13:55", name: "Модерируемая дискуссия", topic: "Обсуждение и быстрый раунд" },
                { time: "13:55 – 14:00", name: "Насима Бахрамова", topic: "Заключение модератора" },
              ]
            : [
                { time: "13:00 – 13:05", name: "Nasima Bahramova — Chairwoman of the Association of E-Commerce Participants of Tajikistan", topic: "Session opening: From online store to investment market: what does Tajikistan’s e-commerce need to scale?" },
                { time: "13:05 – 13:12", name: "Iftikhor Yusufi — LAK LAK marketplace", topic: "A local marketplace as infrastructure for small business growth and investment" },
                { time: "13:12 – 13:19", name: "Muhammadjon Kudratullozoda — e-commerce logistics aggregator", topic: "Last mile and fulfillment as investment infrastructure" },
                { time: "13:19 – 13:26", name: "Gulanor Atobek — fintech company / payment system representative", topic: "E-commerce payment infrastructure: from QR and acquiring to a unified digital transaction" },
                { time: "13:26 – 13:33", name: "Yaroslav Yeferin — Parvona project", topic: "How can entrepreneurs move from social networks to structured e-commerce?" },
                { time: "13:33 – 13:40", name: "Bonu Boboeva — Chief Operating Officer at zehnlab.ai", topic: "How AI and digital automation are changing online retail economics" },
                { time: "13:40 – 13:55", name: "Moderated discussion", topic: "Discussion and rapid round" },
                { time: "13:55 – 14:00", name: "Nasima Bahramova", topic: "Moderator’s closing remarks" },
              ],
    },
    {
      type: "session",
      title:
        lang === "tj" ? "Ҷаласаи 2" : lang === "ru" ? "Сессия 2" : "Session 2",
      subtitle:
        lang === "tj"
          ? "Имкониятҳои сармоягузорӣ"
          : lang === "ru"
            ? "Инвестиционные возможности"
            : "Investment opportunities",
      timeRange: "14:00 – 16:30",
      color: "gold",
      items: [
        {
          time: "14:00 – 14:30",
          photo: speakerDilshod,
          name:
            lang === "tj"
              ? "Дилшод Ҷуразода"
              : lang === "ru"
                ? "Дилшод Джуразода"
                : "Dilshod Jurazoda",
          langLabel: "",
          country:
            lang === "tj"
              ? "Тоҷикистон"
              : lang === "ru"
                ? "Таджикистан"
                : "Tajikistan",
          title:
            lang === "tj"
              ? "Директори генералии Корхонаи воҳиди давлатии «Таджинвест»"
              : lang === "ru"
                ? "Генеральный директор ГУП «Таджинвест»"
                : 'General Director of the State Unitary Enterprise "Tajinvest"',
          topic:
            lang === "tj"
              ? "Имкониятҳои сармоягузории Тоҷикистон"
              : lang === "ru"
                ? "Инвестиционные возможности Таджикистана"
                : "Investment Opportunities in Tajikistan",
          qa: true,
        },
        {
          time: "14:30 – 15:00",
          photo: speakerAnastasia,
          name:
            lang === "tj" || lang === "ru"
              ? "Анастасия Анциферова"
              : "Anastasia Antsiferova",
          langLabel: "",
          country:
            lang === "tj" ? "Русия" : lang === "ru" ? "Россия" : "Russia",
          title:
            lang === "tj"
              ? "Соҳибкор, сухангӯи бизнес ва мутахассис оид ба рушди бизнеси тарабхонаҳо, маркетинг ва идоракунии дастаҳо."
              : lang === "ru"
                ? "Предприниматель, бизнес-спикер и эксперт по развитию ресторанного бизнеса, маркетингу и управлению командой."
                : "Entrepreneur, business speaker and expert in restaurant business development, marketing and team management.",
          topic:
            lang === "tj"
              ? "Эҷоди тарабхонаи консептуалӣ аз сифр ё харидани франшиза: таҷриба аз ду ҷониб"
              : lang === "ru"
                ? "Создать концептуальный ресторан с нуля или купить франшизу: опыт с обеих сторон"
                : "Create a concept restaurant from scratch or buy a franchise: experience from both perspectives",
          qa: true,
        },
        {
          time: "15:00 – 15:30",
          photo: speakerBehdad,
          name:
            lang === "tj"
              ? "Беҳдод Зейнал Ганбар Неҷод"
              : lang === "ru"
                ? "Бехдад Зейнал Ганбар Нежад"
                : "Behdad Zeynal Ghanbar Nezhad",
          langLabel: "",
          country: lang === "tj" ? "Эрон" : lang === "ru" ? "Иран" : "Iran",
          title:
            lang === "tj"
              ? "Муассиси ҶДММ «БуранПарс», соҳибкор ва сафири Маркази содиротии Москва дар Эрон."
              : lang === "ru"
                ? "Учредитель ООО «БуранПарс», предприниматель и амбассадор Московского экспортного центра в Иране."
                : "Founder of BuranPars LLC, entrepreneur and Moscow Export Center Ambassador in Iran.",
          topic:
            lang === "tj"
              ? "Эрон — Осиёи Марказӣ: имкониятҳои нави сармоягузорӣ ва ҳамкорӣ"
              : lang === "ru"
                ? "Иран — Центральная Азия: новые возможности для инвестиций и сотрудничества"
                : "Iran–Central Asia: New Opportunities for Investment and Cooperation",
          qa: true,
        },
        {
          time: "15:30 – 16:00",
          photo: speakerAbdurashid,
          name:
            lang === "tj" || lang === "ru"
              ? "Абдурашид Иминов"
              : "Abdurashid Iminov",
          langLabel: "",
          country:
            lang === "tj"
              ? "Ӯзбекистон"
              : lang === "ru"
                ? "Узбекистан"
                : "Uzbekistan",
          title:
            lang === "tj"
              ? "Асосгузор ва директори генералии Gōsht Group, соҳибкори байналмилалӣ ва мутахассис дар соҳаи тиҷорати тарабхонаҳо ва меҳмоннавозӣ."
              : lang === "ru"
                ? "Основатель и генеральный директор Gōsht Group, международный предприниматель и эксперт в ресторанном и гостиничном бизнесе."
                : "Founder and CEO of Gösht Group, international entrepreneur and expert in the restaurant and hospitality industry",
          topic:
            lang === "tj"
              ? "Стратегияи тавсеаи байналмилалӣ"
              : lang === "ru"
                ? "Стратегия международной экспансии"
                : "International Expansion Strategy",
          qa: true,
        },
        {
          time: "16:00 – 16:30",
          photo: speakerHarpreet,
          name:
            lang === "tj" || lang === "ru"
              ? "Харприт Сингх Маан"
              : "Harpreet Singh",
          langLabel: "(in English)",
          country:
            lang === "tj"
              ? "Малайзия"
              : lang === "ru"
                ? "Малайзия"
                : "Malaysia",
          title:
            lang === "tj"
              ? "Директори генералии TEIZA, Президенти Blockchain Association Malaysia, соҳибкори силсилавӣ ва мутахассис дар соҳаи Blockchain ва DLT."
              : lang === "ru"
                ? "Генеральный директор TEIZA, Президент Blockchain Association Malaysia, серийный предприниматель и эксперт по Blockchain и DLT."
                : "CEO of TEIZA, President of the Blockchain Association Malaysia, serial entrepreneur and expert in Blockchain and DLT",
          topic:
            lang === "tj"
              ? "Тоҷикистони рақамӣ: қалби иқтисоди рақамии Осиёи Марказӣ"
              : lang === "ru"
                ? "Цифровой Таджикистан: сердце цифровой экономики Центральной Азии"
                : "Digital Tajikistan: The Heart of Central Asia's Digital Economy",
          qa: true,
        },
      ],
    },
    {
      type: "block",
      time: "16:30 – 17:00",
      title:
        lang === "tj"
          ? "Ҷамъбасти Форум"
          : lang === "ru"
            ? "Подведение итогов форума"
            : "Forum Summary",
      color: "teal",
    },
    {
      type: "block",
      time: "17:00 – 17:30",
      title:
        lang === "tj"
          ? "Маросими расмии хотимавии форум"
          : lang === "ru"
            ? "Церемония закрытия"
            : "Closing Ceremony",
      color: "teal",
    },
  ];

  return (
    <div className="invest-forum-page">
      {/* ─── HERO ─────────────────────────────────────────────────────── */}
      <div className="if-hero">
        <div
          className="if-hero-bg"
          style={{ backgroundImage: `url(${orig})` }}
        />

        <div
          style={{
            position: "absolute",
            top: -26,
            left: 0,
            width: "100%",
            zIndex: 5000,
          }}
        >
          <Header />
        </div>

        <div className="container if-hero-inner">
          <div className="if-breadcrumb"></div>

          <div className="row align-items-center if-hero-row">
            <div className="col-lg-6">
              <div className="if-logo-lockup">
                <img
                  src={investforum}
                  alt="G10 Insights Forum 2026"
                  className="if-logo-img"
                />
              </div>

              <h1 className="if-hero-title">{t("investForum.heroTitle")}</h1>
              <p className="if-hero-tagline">{t("investForum.heroTagline")}</p>
              {t("investForum.heroTagline2") && (
                <p className="if-hero-tagline-2">
                  {t("investForum.heroTagline2")}
                </p>
              )}

              <div className="if-hero-meta">
                <div className="if-hero-meta-item">
                  <FaMapMarkerAlt />
                  <span>{t("investForum.locationCity")}</span>
                </div>
                <div className="if-hero-meta-item">
                  <FaBuilding />
                  <span>{t("investForum.venue")}</span>
                </div>
                <div className="if-hero-meta-item">
                  <FaRegCalendarAlt />
                  <span>{t("investForum.date")}</span>
                </div>
              </div>

              <div className="if-hero-buttons">
                <a
                  href={TICKET_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="if-btn if-btn-gold"
                >
                  {t("investForum.registerNow")} <FaArrowRight />
                </a>
                <a
                  href={agendaPdf}
                  download={lang === "en" ? "agenda-g10-insights-forum-en.pdf" : "agenda-g10-insights-forum-ru.pdf"}
                  className="if-btn if-btn-outline"
                >
                  {t("investForum.downloadProgram")} <FaArrowRight />
                </a>
              </div>
            </div>
            <div className="col-lg-6"></div>
          </div>
        </div>

        <div className="if-stats-bar">
          <div className="container">
            <div className="row g-3 g-md-0 text-center">
              {stats.map((s, i) => (
                <div className="col-6 col-md-3 if-stat-item" key={i}>
                  <div className="if-stat-icon">{statIcons[i]}</div>
                  <div>
                    <div className="if-stat-value">{s.value}</div>
                    <div className="if-stat-label">{s.label}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ─── ABOUT ────────────────────────────────────────────────────── */}
      <section className="if-section">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <div className="if-eyebrow">{t("investForum.aboutEyebrow")}</div>
              <h2 className="if-h2">{t("investForum.aboutTitle")}</h2>
              <p className="if-body-text">{t("investForum.aboutText1")}</p>
              <p className="if-body-text">{t("investForum.aboutText2")}</p>
            </div>
            <div className="col-lg-6">
              <ImagePlaceholder
                label={t("investForum.aboutImageLabel")}
                className="if-about-image"
                src={aboutForumImg}
              />
            </div>
          </div>
        </div>
      </section>

      {/* ─── MISSION ──────────────────────────────────────────────────── */}
      <section className="if-section if-section-alt">
        <div className="container">
          <div className="if-section-heading">
            {t("investForum.missionHeading")}
          </div>
          <div className="row g-4">
            {missionGoals.map((m, i) => (
              <div className="col-6 col-lg-3" key={i}>
                <div className="if-goal-card">
                  <div className="if-goal-icon">{missionIcons[i]}</div>
                  <div className="if-goal-title">{m.title}</div>
                  <div className="if-goal-text">{m.text}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── SPEAKERS ─────────────────────────────────────────────────── */}
      <section className="if-section">
        <div className="container">
          <div className="if-section-heading">
            {t("investForum.speakersHeading")}
          </div>

          <div
            className="if-speakers-panel"
            onMouseEnter={() => setIsCarouselPaused(true)}
            onMouseLeave={() => setIsCarouselPaused(false)}
          >
            <div
              className="row g-4 justify-content-center if-speakers-fade"
              key={speakerPage}
            >
              {visibleSpeakers.map((sp, i) => (
                <div
                  className="col-6 col-md-4 col-lg-2"
                  key={speakerPage * SPEAKERS_PER_PAGE + i}
                >
                  <div className="if-speaker-card">
                    <ImagePlaceholder
                      src={visibleSpeakerPhotos[i]}
                      label={t("investForum.speakerPhotoLabel")}
                      className="if-speaker-photo"
                      alt={sp.name}
                    />
                    <div className="if-speaker-name">{sp.name}</div>
                    <div className="if-speaker-title">{sp.title}</div>
                    {sp.topic && (
                      <div className="if-speaker-topic">{sp.topic}</div>
                    )}
                    {(sp.linkedin || sp.instagram) && (
                      <div className="if-speaker-socials">
                        {sp.linkedin && (
                          <a
                            href={sp.linkedin}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="LinkedIn"
                            className="if-speaker-social-link"
                          >
                            <FaLinkedin />
                          </a>
                        )}
                        {sp.instagram && (
                          <a
                            href={sp.instagram}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Instagram"
                            className="if-speaker-social-link"
                          >
                            <FaInstagram />
                          </a>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {speakerPageCount > 1 && (
              <div className="if-dots">
                {Array.from({ length: speakerPageCount }).map(
                  (_, pageIndex) => (
                    <span
                      key={pageIndex}
                      className={pageIndex === speakerPage ? "active" : ""}
                      onClick={() => setSpeakerPage(pageIndex)}
                      role="button"
                      tabIndex={0}
                      aria-label={`Speakers page ${pageIndex + 1}`}
                    />
                  ),
                )}
              </div>
            )}
          </div>
        </div>
      </section>

      {/* ─── AGENDA ───────────────────────────────────────────────────── */}
      <section className="if-section if-section-alt">
        <div className="container">
          <div className="if-section-heading">
            {t("investForum.agendaEyebrow")}
          </div>

          <div className="if-agenda-wrapper">
            {detailedAgenda.map((item, idx) => {
              if (item.type === "block") {
                return (
                  <div
                    key={idx}
                    className={`if-agenda-block if-agenda-block--${item.color}`}
                  >
                    <div className="if-agenda-block-time">{item.time}</div>
                    <div className="if-agenda-block-title">{item.title}</div>
                  </div>
                );
              }

              if (item.type === "session") {
                return (
                  <div key={idx} className="if-agenda-session">
                    <div className="if-agenda-session-header">
                      <div className="if-agenda-session-left">
                        <span className="if-agenda-session-label">
                          {item.title}
                        </span>
                        <span className="if-agenda-session-subtitle">
                          {item.subtitle}
                        </span>
                      </div>
                      <div className="if-agenda-session-range">
                        {item.timeRange}
                      </div>
                    </div>

                    <div className="if-agenda-speakers">
                      {item.items.map((sp, i) => (
                        <div key={i} className="if-agenda-speaker-card">
                          <div className="if-agenda-speaker-time">
                            {sp.time}
                          </div>

                          <div className="if-agenda-speaker-main">
                            <div className="if-agenda-speaker-photo">
                              <img src={sp.photo} alt={sp.name} />
                            </div>
                            <div className="if-agenda-speaker-info">
                              <div className="if-agenda-speaker-name">
                                {sp.name}{" "}
                                {sp.langLabel && (
                                  <span className="if-agenda-lang">
                                    {sp.langLabel}
                                  </span>
                                )}
                                {sp.country && (
                                  <span className="if-agenda-country">
                                    {" "}
                                    • {sp.country}
                                  </span>
                                )}
                              </div>
                              <div className="if-agenda-speaker-title">
                                {sp.title}
                              </div>
                              <div className="if-agenda-topic-label">
                                {lang === "tj"
                                  ? "Мавзӯи баромад"
                                  : lang === "ru"
                                    ? "Тема выступления"
                                    : "Speech Topic"}
                              </div>
                              <div className="if-agenda-topic">{sp.topic}</div>
                            </div>
                          </div>

                          {sp.qa && (
                            <div className="if-agenda-qa">
                              {lang === "tj"
                                ? "Саволу ҷавоб · 5 дақ"
                                : lang === "ru"
                                  ? "Вопросы и ответы · 5 мин"
                                  : "Q&A · 5 MIN"}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                );
              }

              if (item.type === "panel") {
                return (
                  <div key={idx} className="if-agenda-panel">
                    <div className="if-agenda-panel-time">{item.time}</div>
                    <div className="if-agenda-panel-content">
                      <div className="if-agenda-panel-title">{item.title}</div>
                      <div className="if-agenda-panel-subtitle">
                        {item.subtitle}
                      </div>
                      <div className="if-agenda-moderator">
                        <strong>
                          {lang === "tj"
                            ? "Модератор:"
                            : lang === "ru"
                              ? "Модератор:"
                              : "Moderator:"}
                        </strong>{" "}
                        {item.moderator}
                        <br />
                        <span>{item.moderatorTitle}</span>
                      </div>
                      <div className="if-agenda-panelists">
                        <div className="if-agenda-panelists-label">
                          {item.panelistsLabel}
                        </div>
                        <div className="if-agenda-panelists-grid">
                          {item.panelists.map((p, pi) => (
                            <div key={pi} className="if-agenda-panelist">
                              <div className="if-agenda-panelist-time">
                                {p.time}
                              </div>
                              <div className="if-agenda-panelist-name">
                                {p.name}
                              </div>
                              <div className="if-agenda-panelist-topic">
                                {p.topic}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }

              return null;
            })}
          </div>

          <div className="if-agenda-format-note">
            <span className="if-agenda-format-icon">i</span>
            <div>
              <strong>
                {lang === "tj"
                  ? "Формати баромад"
                  : lang === "ru"
                    ? "Формат выступления"
                    : "Speaking format"}
              </strong>
              <br />
              {lang === "tj"
                ? "25 дақиқа барои муаррифии баромадкунанда + 5 дақиқа барои саволу ҷавоб"
                : lang === "ru"
                  ? "25 минут на презентацию спикера + 5 минут на вопросы и ответы"
                  : "25 minutes for the speaker’s presentation + 5 minutes for Q&A"}
            </div>
          </div>
        </div>
      </section>

      {/* ─── EXPO ─────────────────────────────────────────────────────── */}
      <section className="if-section">
        <div className="container">
          <div className="if-section-heading">
            {t("investForum.expoHeading")}
          </div>
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <h3 className="if-h2 if-expo-title-main">
                {t("investForum.expoTitle")}
              </h3>
              <p className="if-body-text">{t("investForum.expoText")}</p>
              <p className="if-body-text if-expo-deadline">
                {t("investForum.expoDeadline")}
              </p>
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSdDxAgdVXGKXqctnRN2zp8FdCU9U1saLWQOOVHdye2bTiiPTw/viewform?usp=header"
                target="_blank"
                rel="noopener noreferrer"
                className="if-btn if-btn-gold"
              >
                {t("investForum.expoButton")} <FaArrowRight />
              </a>
            </div>
            <div className="col-lg-6">
              <ImagePlaceholder
                label={t("investForum.expoImageLabel")}
                className="if-expo-image"
                src={hand}
              />
            </div>
          </div>
        </div>
      </section>

      {/* ─── OUTCOMES ─────────────────────────────────────────────────── */}
      <section className="if-outcomes-bar">
        <div className="container">
          <div className="if-section-heading if-section-heading-gold">
            {t("investForum.outcomesHeading")}
          </div>
          <div className="row g-4">
            {expectedOutcomes.map((o, i) => (
              <div className="col-6 col-lg-2" key={i}>
                <div className="if-outcome-item">
                  <div className="if-outcome-icon">{outcomeIcons[i]}</div>
                  <div className="if-outcome-title">{o.title}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── PARTNERS ─────────────────────────────────────────────────── */}
      <section className="if-section if-org-partners-section">
        <div className="container">
          <div className="if-org-partners-row">
            <div className="if-partners-block" style={{ width: "100%" }}>
              <div className="if-org-heading">
                {t("investForum.partnersHeading")}
              </div>

              <div className="if-partners-groups">
                {partnerGroups.map((group, gi) => (
                  <div key={gi} className="if-partner-group">
                    <div className="if-partner-category">
                      {partnerCategories[group.categoryKey] || ""}
                    </div>
                    <div className="if-partner-logos-grid">
                      {group.logos.map((logo, i) => (
                        <div className="if-partner-logo-tile" key={i}>
                          <img
                            src={logo.src}
                            alt={logo.alt}
                            className={logo.className || ""}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
{/* bilol */}
      {/* ─── CTA ──────────────────────────────────────────────────────── */}
      <section className="if-cta-bar">
        <div className="container">
          <div className="if-cta-inner">
            <div>
              <div className="if-cta-title">{t("investForum.ctaTitle")}</div>
              <div className="if-cta-subtitle">
                {t("investForum.ctaSubtitle")}
              </div>
            </div>
            <div className="if-cta-buttons">
              <a
                href={TICKET_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="if-btn if-btn-gold"
              >
                {t("investForum.registerNow")} <FaArrowRight />
              </a>
              <a
                href={agendaPdf}
                download={lang === "en" ? "agenda-g10-insights-forum-en.pdf" : "agenda-g10-insights-forum-ru.pdf"}
                className="if-btn if-btn-outline"
              >
                {t("investForum.downloadProgram")} <FaArrowRight />
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default InvestForum;
